export const UNIT_MULTIPLIER_TO_CM = { cm: 1, m: 100, in: 2.54, ft: 30.48, mm: 0.1 }
export const UNIT_MULTIPLIER_TO_KM = {
  cm: 0.00001,
  m: 0.001,
  in: 0.0000254,
  ft: 0.00003048,
  mm: 0.000001
}
export const UNIT_MULTIPLIER_TO_MILES = { m: 0.000621371, km: 0.621371, mm: 0.000000621371 }
export const UNIT_MULTIPLIER_FROM_X3_TO_M3 = {
  m: 1,
  cm: 0.000001,
  mm: 0.000000001,
  in: 0.0000163871,
  ft: 0.0283168
}
export const UNIT_MULTIPLIER_FROM_X3_TO_CM3 = {
  cm: 1,
  in: 16.387064,
  ft: 28316.8466,
  m: 1000000,
  mm: 0.001
}
export const UNIT_MULTIPLIER_TO_KG = { kg: 1, lbs: 0.45, g: 0.001 }
export const UNIT_MULTIPLIER_TO_MIN = { m: 1, s: 0.016667 }
export const UNIT_MULTIPLIER_TO_HOUR = { h: 1, s: 0.00027777778 }
